import { useEffect, useRef } from "react";
import { Modal, message } from "antd";
import { useTranslation } from "react-i18next";
import Colors from "../../../../themes/Colors";

const useCampaignActions = ({
  history,
  deleteCampaign,
  archiveCampaign,
  loadingDeleteCampaign,
  loadingArchiveCampaign,
  errors,
}) => {
  const { t } = useTranslation();
  const prevDeleting = useRef(loadingDeleteCampaign);
  const prevArchiving = useRef(loadingArchiveCampaign);

  useEffect(() => {
    if (prevDeleting.current && !loadingDeleteCampaign) {
      if (!errors || errors.length === 0) {
        message.success(t("Campaign successfully removed"));
      } else if (errors[0] === "You cannot delete a campaign with payments.") {
        message.error(t("You cannot delete campaigns with payments created"), 6);
      } else {
        message.error(t("An error occurred while deleting campaign"));
      }
    }
    prevDeleting.current = loadingDeleteCampaign;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingDeleteCampaign]);

  useEffect(() => {
    if (prevArchiving.current && !loadingArchiveCampaign) {
      if (!errors || errors.length === 0) {
        message.success(t("Operation completed successfully"));
      }
    }
    prevArchiving.current = loadingArchiveCampaign;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingArchiveCampaign]);

  const goToDetail = (campaign) => {
    if (history) history.push(`/campaign/${campaign.id}`);
  };

  const goToEdit = (campaign) => {
    if (history) history.push(`/campaign/${campaign.id}?edit=1`);
  };

  const requestDelete = (campaign) =>
    Modal.confirm({
      title: t("Delete campaign"),
      content: t("This action cannot be undone."),
      okText: t("Delete"),
      okType: "danger",
      okButtonProps: {
        style: {
          background: Colors.red,
          borderColor: Colors.red,
          color: Colors.white,
        },
      },
      cancelText: t("Cancel"),
      onOk: () => deleteCampaign(campaign.id),
    });

  const requestArchive = (campaign) =>
    Modal.confirm({
      title: campaign.archived ? t("Unarchive") : t("Archive"),
      content: campaign.archived
        ? t("Do you want to unarchive this campaign?")
        : t("Do you want to archive this campaign?"),
      okText: t("Accept"),
      cancelText: t("Cancel"),
      okButtonProps: {
        style: {
          background: Colors.primary,
          borderColor: Colors.primary,
          color: Colors.onPrimary,
        },
      },
      onOk: () => archiveCampaign(campaign.id, { archived: !campaign.archived }),
    });

  return { goToDetail, goToEdit, requestDelete, requestArchive };
};

export default useCampaignActions;
